<div class="component-container water-connection-container">
  <app-review-section
    #waterConnectionSection
    [title]="waterConnectionHeaderTranslationKey | translate"
    [tooltip]="'tooltips.technician-form.water-connection' | translate"
    [showTooltip]="showWaterSupplyInfo"
    [sectionId]="sectionIdentifier.TechnicalData_BaseData_Water"
    [applicationId]="applicationId"
    [isDetailsView]="isDetailsView">
    <form [formGroup]="waterConnectionFG" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-section form-font-size">
      <div class="form-background">
        <div class="ui-g form-rows" *ngIf="showPeakFlow">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label for="water-connection-peak-flow" class="ui-g-5 field-label text-right-align" [class.required]="peakFlowRequired">
              {{ 'technician-data.form-fields.peak-flow' | translate }}
            </label>
            <input
              class="ui-input pInputText small-width"
              formControlName="peakFlow"
              id="water-connection-peak-flow"
              appFloatNumber="2"
              isPeakFlow="true"
              pInputText
              size="30"
              [readonly]="!waterConnectionSection.isDataEditable" />
            <span class="field-unit-label">{{ showPeakFlowRateAsVolumeFlowRate ? unitLabels.volumeFlowRate : unitLabels.peakFlow }}</span>
          </div>
          <div class="ui-g-6 field-rows padding-left-1" *ngIf="showInfoForCommodities">
            <span [innerHTML]="'technician-data.standard-water-warning' | translate"></span>
          </div>
        </div>
        <ng-container *ngIf="!hiddenFields.waterConnectionCheckBoxesAndDropdowns">
          <div *ngIf="showPeakFlowConfirmationCheckboxes">
            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <p-checkbox
                  appEnterClick
                  formControlName="rentOfWaterManhole"
                  id="rent-water-manhole"
                  [value]="true"
                  [label]="'technical-data.rent-of-water-manhole' | translate"
                  [readonly]="!waterConnectionSection.isDataEditable"></p-checkbox>
              </div>
            </div>
            <div class="ui-g form-rows">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <p-checkbox
                  appEnterClick
                  formControlName="confirmFrostProtection"
                  id="confirm-frost-protection"
                  [value]="true"
                  [label]="'technical-data.confirm-frost-protection' | translate"
                  [readonly]="!waterConnectionSection.isDataEditable"></p-checkbox>
              </div>
            </div>
          </div>

          <div *ngIf="currentInstallationFlow === installationFlowType.MainsConnection" class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="waterConnectionFG.get('specialService')">
              <label class="ui-g-5"></label>
              <p-checkbox
                appEnterClick
                binary="true"
                [readonly]="!waterConnectionSection.isDataEditable"
                class="checkbox-field"
                formControlName="specialService"
                id="water-connection-special-service"
                label="{{ 'technician-data.form-fields.special-service-checkbox' | translate }}"></p-checkbox>
            </div>
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="waterConnectionFG.get('description')">
              <label for="water-connection-description" class="ui-g-5 field-label text-right-align">
                {{ 'technician-data.form-fields.description' | translate }}
              </label>
              <input
                class="ui-input pInputText"
                formControlName="description"
                id="water-connection-description"
                pInputText
                size="30"
                type="text"
                [readonly]="!waterConnectionSection.isDataEditable" />
            </div>

            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="waterConnectionFG.get('swknParcelSize')">
              <label for="water-connection-parcel-size" class="ui-g-5 field-label text-right-align">
                {{ 'technician-data.form-fields.swkn-parcel-size' | translate }}
              </label>
              <input
                class="ui-input pInputText small-width"
                formControlName="swknParcelSize"
                id="water-connection-parcel-size"
                pInputText
                size="30"
                [appNumber]="true"
                [readonly]="!waterConnectionSection.isDataEditable" />
              <span class="field-unit-label">{{ unitLabels.area }}</span>
            </div>
          </div>

          <div *ngIf="currentInstallationFlow === installationFlowType.MainsConnection" class="ui-g form-rows">
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="waterConnectionFG.get('fireWater')">
              <label class="ui-g-5"></label>
              <p-checkbox
                appEnterClick
                binary="true"
                [readonly]="!waterConnectionSection.isDataEditable"
                class="checkbox-field"
                (onChange)="updateFireWaterProperty()"
                formControlName="fireWater"
                id="water-connection-fire-water"
                label="{{ 'technician-data.form-fields.fire-water-checkbox' | translate }}"></p-checkbox>
            </div>
            <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows" *ngIf="waterConnectionFG.get('institutionType')">
              <label class="ui-g-5 field-label text-right-align" for="water-connection-institution-type">
                {{ 'technician-data.form-fields.institution-type' | translate }}
              </label>
              <input
                class="ui-input pInputText"
                formControlName="institutionType"
                id="water-connection-institution-type"
                pInputText
                size="30"
                type="text"
                [readonly]="!waterConnectionSection.isDataEditable" />
            </div>

            <div
              class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows"
              *ngIf="waterConnectionFG.get('swknFirewaterPeakflow')">
              <label
                class="ui-g-5 field-label text-right-align"
                [class.required]="isSwknFirewaterPeakflowRequired"
                for="water-connection-firewater-peakflow">
                {{ 'technician-data.form-fields.swkn-firewater-peakflow' | translate }}
              </label>
              <input
                class="ui-input pInputText small-width"
                formControlName="swknFirewaterPeakflow"
                id="water-connection-firewater-peakflow"
                pInputText
                size="30"
                [appNumber]="true"
                [readonly]="!waterConnectionSection.isDataEditable" />
              <span class="field-unit-label">{{ unitLabels.volumeFlowRate }}</span>
            </div>
          </div>

          <div *ngIf="currentInstallationFlow === installationFlowType.MainsConnection && currentFormType.index > 0" class="ui-g-12">
            <div class="ui-g form-rows" *ngIf="waterConnectionFG.get('singleBillCheckbox')">
              <div class="ui-g-12 field-rows">
                <label class="ui-g-3"></label>
                <p-checkbox
                  appEnterClick
                  binary="true"
                  [readonly]="!waterConnectionSection.isDataEditable"
                  class="checkbox-field left-padding"
                  formControlName="singleBillCheckbox"
                  id="single-bill-checkbox"
                  label="{{ 'technician-data.form-fields.single-bill-checkbox' | translate }}"></p-checkbox>
              </div>
            </div>

            <div class="ui-g form-rows" *ngIf="waterConnectionFG.get('waterHeatingType')">
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align" for="water-heating-type">
                  {{ 'technician-data.form-fields.water-heating-type' | translate }}
                </label>
                <p-dropdown
                  [options]="waterHeatingType"
                  [readonly]="!waterConnectionSection.isDataEditable"
                  formControlName="waterHeatingType"
                  id="water-heating-type"
                  placeholder="-Select-">
                  <ng-template let-item pTemplate="selectedItem">
                    <span class="drop-item-label">
                      {{ 'lookup.' + waterHeatingTypeKey + '.options.' + item['value'] + '.name' | translate }}
                    </span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="drop-item">
                      <span class="drop-item-label">
                        {{ 'lookup.' + waterHeatingTypeKey + '.options.' + option['value'] + '.name' | translate }}
                      </span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </app-review-section>
</div>
